<!--
 * @Author: zfd
 * @Date: 2020-09-06 22:55:17
 * @LastEditTime: 2020-09-06 23:15:39
 * @Description: 
 * @FilePath: \trip-enterprise\src\components\RecursiveMenu.vue
-->
<template>
  <el-submenu v-if="submenu.Children" :index="submenu.Controller + submenu.Action">
    <template slot="title">
      <i :class="submenu.Icon"></i>
      <span>{{submenu.Name}}</span>
    </template>
    <recursive-menu v-for="child in submenu.Children" :submenu="child" :key="child.Id"></recursive-menu>
  </el-submenu>

  <el-menu-item v-else :index="submenu.Controller + submenu.Action">
    <template slot="title">
      <i :class="submenu.Icon"></i>
      <span>{{submenu.Name}}</span>
    </template>
  </el-menu-item>
</template>

<script>
export default {
  name: "RecursiveMenu",
  props: ["submenu"],
};
</script>

<style>
</style>